import { render, staticRenderFns } from "./ManualOtherInput.vue?vue&type=template&id=4758ec6a&"
import script from "./ManualOtherInput.vue?vue&type=script&lang=ts&"
export * from "./ManualOtherInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports